import { equals, isNil, lensProp, view } from 'ramda'

import { NonNullableProps, NullProps } from '../../utils/types'

export const isProductNotNil = <T extends { product: unknown | undefined }>(
  val: T,
): val is NonNullableProps<T, 'product'> => !isNil(val.product)

export const isProductNil = <T extends { product: unknown | undefined }>(
  val: T,
): val is NullProps<T, 'product'> => isNil(val.product)

interface WithSkuProp {
  sku: string
}

const skuLens = lensProp<WithSkuProp>('sku')

export const skuProp = view(skuLens)

export const skuPropEquals =
  (obj1: WithSkuProp) =>
  (obj2: WithSkuProp): boolean =>
    equals(skuProp(obj1), skuProp(obj2))
